/**
 * Created by jyothi on 22/8/17.
 */
export const SERVER_IDENTIFIERS = {
    google: "google",
    azure: "azure",
    aws: "aws"
};